export default __webpack_public_path__ + "static/media/RegisterRight.936eb6e3.svg";